module.exports = __webpack_public_path__ + "static/media/mobile-tombeau-cover.635b54a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/mobile-tombeau-cover.jpg
// module id = 602
// module chunks = 0